import React from 'react'
import { Field } from 'redux-form'
import {
    Create,
    SimpleForm,
    ReferenceInput,
    SelectInput,
    SelectArrayInput
} from 'react-admin'

import {ReferenceSelectInput} from '../Inputs'

export const PermisoCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <ReferenceInput label="Usuario" source="user" reference="usuarios">
                <SelectInput optionText="username" />
            </ReferenceInput>
            <Field
                name={"empresa"}
                label={"Empresa"}
                required={true}
                component={ReferenceSelectInput}
                reference={"empresas"}
                isDisabled={false}
            />
            <SelectArrayInput label="Permisos" source="permissions" choices={[
                { id: 'read', name: 'Ver' },
                { id: 'edit', name: 'Editar' },
                { id: 'admin_users', name: 'Administrar Usuarios' }
            ]} />
        </SimpleForm>
    </Create>
);
